export const QUERY_GET_LOCATIONS = `
query getLocations {
  locations(first: 50) {
    edges {
      node {
        id
        name
      }
    }
  }
}
`;

export const QUERY_GET_ORDERS_LIST = `
query getOrdersList($first: Int!, $query: String) {
  orders(first: $first, query: $query, sortKey: CREATED_AT, reverse: true) {
    edges {
      node {
        id
        name
        createdAt
        sourceIdentifier
        customAttributes {
          key
          value
        }
        lineItems(first: 20) {
          edges {
            node {
              title
              quantity
            }
          }
        }
      }
    }
  }
}
`;

export const QUERY_GET_COMPANY_LOCATIONS = `
query getCompanyLocations($ids: [ID!]!) {
  nodes(ids: $ids) {
    ... on CompanyLocation {
      id
      name
    }
  }
}
`;

export const MUTATION_STAGED_UPLOADS_CREATE = `
mutation stagedUploadsCreate($input: [StagedUploadInput!]!) {
  stagedUploadsCreate(input: $input) {
    stagedTargets {
      url
      resourceUrl
      parameters {
        name
        value
      }
    }
    userErrors {
      field
      message
    }
  }
}
`;

export const MUTATION_FILE_CREATE = `
mutation fileCreate($files: [FileCreateInput!]!) {
  fileCreate(files: $files) {
    files {
      id
      fileStatus
      alt
      createdAt
      ... on MediaImage {
        image {
          width
          height
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
`;

export const MUTATION_METAFIELD_SET = `
mutation metafieldsSet($metafields: [MetafieldsSetInput!]!) {
  metafieldsSet(metafields: $metafields) {
    metafields {
      id
      key
      namespace
      value
      type
    }
    userErrors {
      field
      message
    }
  }
}
`;
